import React from 'react';
import cc from 'classcat';

import styles from './styles.module.scss';

interface Props {
  children?: JSX.Element[] | JSX.Element;
  height?: number;
  image?: Nullable<string>;
}

const HeroImage = ({ children, height, image }: Props) => {
  return (
    <div
      className={cc({ [styles.heroImage]: true, [styles.relative]: children })}
      style={{
        height: height || 'unset',
      }}
    >
      {image && <img className={styles.backgroundImage} alt="" />}
      {children && <div className={styles.children}>{children}</div>}
    </div>
  );
};

export default HeroImage;
